import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'lg', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => Richtext,
    _customProps: {
      Component: FDBodyText, size: 'sm', align: 'center', color: 'textDisabled',
    },
  }, overrideReadOnly);
